/**
 * Offline Status Banner
 * FT-236: Shows notification when device goes offline
 * Persists until device comes back online
 */

import React from 'react';
import { WifiOff } from 'lucide-react';

export const OfflineStatusBanner = () => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-white px-4 py-3 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-center">
        <div className="flex items-center space-x-3">
          <WifiOff className="h-5 w-5" />
          <span className="text-sm font-medium">
            You're offline. Changes will sync when you reconnect.
          </span>
        </div>
      </div>
    </div>
  );
};

export default OfflineStatusBanner;
